module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Roll-On-The_Ground-Web-1280.2b8e4574.jpg";